// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/product/product.proto" (package "mlmbox.client.product", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Product } from "./product.ts";
import type { Invoice_VerifiedResponse } from "../../types/product.ts";
import type { Invoice_PreviewResponse } from "../../types/product.ts";
import type { Invoice_Request } from "../../types/product.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AiLinkResponse } from "../../types/product.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.product.Product
 */
export interface IProductClient {
    /**
     * @generated from protobuf rpc: GetAiLink(google.protobuf.Empty) returns (mlmbox.types.AiLinkResponse);
     */
    getAiLink(input: Empty, options?: RpcOptions): UnaryCall<Empty, AiLinkResponse>;
    /**
     * @generated from protobuf rpc: PreviewPurchase(mlmbox.types.Invoice.Request) returns (mlmbox.types.Invoice.PreviewResponse);
     */
    previewPurchase(input: Invoice_Request, options?: RpcOptions): UnaryCall<Invoice_Request, Invoice_PreviewResponse>;
    /**
     * @generated from protobuf rpc: VerifiedPurchase(mlmbox.types.Invoice.Request) returns (mlmbox.types.Invoice.VerifiedResponse);
     */
    verifiedPurchase(input: Invoice_Request, options?: RpcOptions): UnaryCall<Invoice_Request, Invoice_VerifiedResponse>;
}
/**
 * @generated from protobuf service mlmbox.client.product.Product
 */
export class ProductClient implements IProductClient, ServiceInfo {
    typeName = Product.typeName;
    methods = Product.methods;
    options = Product.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAiLink(google.protobuf.Empty) returns (mlmbox.types.AiLinkResponse);
     */
    getAiLink(input: Empty, options?: RpcOptions): UnaryCall<Empty, AiLinkResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, AiLinkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PreviewPurchase(mlmbox.types.Invoice.Request) returns (mlmbox.types.Invoice.PreviewResponse);
     */
    previewPurchase(input: Invoice_Request, options?: RpcOptions): UnaryCall<Invoice_Request, Invoice_PreviewResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<Invoice_Request, Invoice_PreviewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VerifiedPurchase(mlmbox.types.Invoice.Request) returns (mlmbox.types.Invoice.VerifiedResponse);
     */
    verifiedPurchase(input: Invoice_Request, options?: RpcOptions): UnaryCall<Invoice_Request, Invoice_VerifiedResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Invoice_Request, Invoice_VerifiedResponse>("unary", this._transport, method, opt, input);
    }
}
